import { connect } from "react-redux";
import Milestone from "./Milestone";

import {
  milestones as milestonesSelector,
  milestonesPagination as milestonesPaginationSelector,
  milestoneItem as currentMilestoneSelector,
  milestonesLoading as milestonesLoadingSelector,
  milestoneLoading as milestoneLoadingSelector,
  milestoneActionLoading as milestoneActionLoadingSelector,
  milestoneError as milestoneErrorSelector
} from "../../store/selectors/milestone.selector";

import {
  getMilestonesRequest,
  createMilestoneRequest,
  updateMilestoneRequest,
  deleteMilestoneRequest,
  clearCurrentMilestoneRequest,
  resetMilestoneErrorsRequest,
  getMilestoneRequest
} from "../../store/actions/milestone.actions";


const mapDispatchToProps = {
  getMilestonesRequest,
  getMilestoneRequest,
  createMilestoneRequest,
  updateMilestoneRequest,
  deleteMilestoneRequest,
  clearCurrentMilestoneRequest,
  resetMilestoneErrorsRequest
};

const mapStateToProps = (state) => {

  const milestones = milestonesSelector(state);
  const pagination = milestonesPaginationSelector(state);
  const currentMilestone = currentMilestoneSelector(state);
  const loading = milestonesLoadingSelector(state);
  const milestoneLoading = milestoneLoadingSelector(state);
  const actionLoading = milestoneActionLoadingSelector(state);
  const error = milestoneErrorSelector(state);

  return {
    milestones,
    pagination,
    currentMilestone,
    loading,
    actionLoading,
    milestoneLoading,
    error,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Milestone);
